import { render, staticRenderFns } from "./MediaPlayerHeader.vue?vue&type=template&id=2aaf41e4&scoped=true&"
import script from "./MediaPlayerHeader.vue?vue&type=script&lang=js&"
export * from "./MediaPlayerHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aaf41e4",
  null
  
)

export default component.exports